var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ECF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0791 10.6148L17.0791 8.11485C16.8963 8.03903 16.7004 8 16.5025 8C16.3047 8 16.1087 8.03903 15.926 8.11485L9.92598 10.6148C9.3666 10.8461 9.00098 11.393 9.00098 11.9992C9.00098 18.2023 12.5791 22.4898 15.9229 23.8836C16.2916 24.0367 16.7072 24.0367 17.076 23.8836C19.7541 22.768 24.001 18.9148 24.001 11.9992C24.001 11.393 23.6354 10.8461 23.0791 10.6148ZM16.6947 22.9617C16.5697 23.0117 16.4322 23.0117 16.3104 22.9617C13.251 21.7492 10.001 17.4992 10.001 11.9992C10.001 11.7961 10.1229 11.6148 10.3072 11.5367L16.3072 9.03672C16.4291 8.98672 16.5697 8.98672 16.6916 9.03672L22.6916 11.5367C22.8791 11.6148 23.001 11.7961 22.9979 11.9992C23.001 17.4992 19.751 21.7492 16.6947 22.9617V22.9617ZM20.951 12.8055C20.8041 12.6586 20.5666 12.6586 20.4197 12.8023L15.3135 17.868L13.1572 15.6961C13.0104 15.5492 12.7729 15.5492 12.626 15.693L12.3604 15.9586C12.2135 16.1055 12.2135 16.343 12.3572 16.4898L15.0416 19.1961C15.1885 19.343 15.426 19.343 15.5729 19.1992L21.2135 13.6055C21.3604 13.4586 21.3604 13.2211 21.2166 13.0742L20.951 12.8055Z",
    fill: "#004288"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shield.664fcdeb5a808f7f2b91da1fb667b7a8.svg";